import React, { useState, Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import setAuthToken from "../utils/setAuthToken";
import { editListing } from "../actions/listing";

const EditListingForm = ({ editlisting, history, editListing }) => {
  // Form State

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    description: "",
    price: "",
    qty: "",
    photo: "",
  });

  // Destructure Form State
  const { name, description, price, qty, photo, id } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setAuthToken(localStorage.token);
    editListing(formData, history);
  };

  useEffect(() => {
    console.log("Edit form", editlisting);
    setFormData({
      id: !editlisting.id ? "" : editlisting.id,
      name: !editlisting.name ? "" : editlisting.name,
      description: !editlisting.description ? "" : editlisting.description,
      price: !editlisting.price ? "" : editlisting.price,
    });
  }, [editlisting]);

  const fileSelectedHandler = (e) => {
    setFormData({
      ...formData,
      photo: e.target.files[0],
    });
    console.log(formData);
  };

  return (
    <div>
      <Fragment>
        <h1 className='large text-primary'>Edit Listing</h1>
        <p>* required field</p>
        <form className='form' onSubmit={handleSubmit}>
          <div className='form-group'>
            <input
              type='text'
              placeholder='* Name'
              name='name'
              value={name}
              onChange={(e) => onChange(e)}
              required
            />
          </div>
          <div className='form-group'>
            <input
              type='text'
              placeholder='* Description'
              name='description'
              value={description}
              onChange={(e) => onChange(e)}
              required
            />
          </div>
          <div className='form-group'>
            <input
              type='number'
              name='price'
              placeholder='* Price'
              value={price}
              onChange={(e) => onChange(e)}
              required
            />
          </div>
          <div className='form-group'>
            <input type='file' onChange={fileSelectedHandler} />
          </div>
          <input type='submit' className='btn btn-primary my-1' />
          <Link className='btn btn-light my-1' to='/my-listings'>
            Go Back
          </Link>
        </form>
      </Fragment>
    </div>
  );
};

const mapStateToProps = (state) => ({
  editlisting: state.listing.editlisting,
});

export default connect(mapStateToProps, { editListing })(
  withRouter(EditListingForm)
);
